<template>
  <div class="wrapper">
    <!-- 轮值主席 -->
    <b-container>
      <intro-scroll :introList="introList"></intro-scroll>
      <div class="Introduction" v-html="detailedIntroduction"></div>
    </b-container>
  </div>
</template>
<script>
import introScroll from "@/forumcomponents/introScroll";

export default {
  components: {
    introScroll,
  },
  data() {
    return {
      introList: [],
      type:2,
    detailedIntroduction:'<p style=\"margin: 8px 0px; padding: 0px; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"><span style=\"font-size: medium;\"><strong>个人简介：</strong></span></p>\n<p style=\"margin: 8px 0px; padding: 0px; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"><span style=\"font-size: medium;\">张磊先生是高瓴资本创始人兼首席执行官，2002年于耶鲁大学毕业，获工商管理和国际关系双硕士学位。&nbsp;</span></p>\n<p style=\"margin: 8px 0px; padding: 0px; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"><span style=\"font-size: medium;\">高瓴资本成立于2005年，专注于发现价值，创造价值，是亚洲最大的投资机构之一。高瓴资本受托管理的资金主要来自于目光长远的全球性机构投资人，包括全球顶尖大学的捐赠基金、主权财富基金、养老基金及家族基金等。作为具有全球视野的长期价值投资者，高瓴资本以创造可持续的长期增长为目标，通过科技创新，在全球尤其是亚洲范围内寻找最优秀的企业家和管理团队，共同创造价值。高瓴资本的投资覆盖TMT、生命健康、消费零售和企业服务等领域。</span></p>\n<p style=\"margin: 8px 0px; padding: 0px; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"><span style=\"font-size: medium;\">张磊先生投入了大量精力支持科研和教育。除了担任未来论坛理事会轮值主席以及未来科学大奖捐赠人之外，张磊先生现任美国耶鲁大学校董会董事、耶鲁大学亚洲发展委员会主席、中国人民大学校董事会副董事长。张磊先生捐赠创立了中国人民大学高礼研究院和中国人民大学高瓴人工智能学院。此外，张磊先生还是中国第一所聚焦基础性前沿科学的创新型研究大学&mdash;&mdash;西湖大学创始捐赠人及创校校董，并担任西湖大学发展委员会主席。</span></p>\n<p style=\"margin: 5px 0px; padding: 0px; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"><span style=\"font-size: medium;\">&nbsp;</span></p>\n<p style=\"margin: 5px 0px; padding: 0px; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"><span style=\"font-size: medium;\">&nbsp;</span></p>\n<p style=\"margin: 5px 0px; padding: 0px; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"><span style=\"font-size: medium;\"><strong>个人语录：</strong></span></p>\n<p style=\"margin: 5px 0px; padding: 0px; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"><span style=\"font-size: medium;\"><span style=\"text-align: justify;\">Science is fun, &nbsp;science is cool</span>；</span></p>\n<p style=\"margin: 5px 0px; padding: 0px; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"><span style=\"font-size: medium;\"><span style=\"text-align: justify;\">Science is wonder, &nbsp;science is future</span>；</span></p>\n<p style=\"margin: 5px 0px; padding: 0px; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"><span style=\"font-size: medium;\"><span style=\"text-align: justify;\">Science is light, &nbsp;science is sunshine</span>！</span></p>\n<p style=\"margin: 5px 0px; padding: 0px; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">&nbsp;</p>'

    };
  },
  created() {
  },
  watch: {
     $route: {
        handler(to) {
          this.type = to.query.type;
         // console.log('this.type-------',this.type)
          this.getList(this.type)
        },
        immediate: true,
        deep: true
      },
  },
  methods: {
    getList() {
         this.$forumApi
        .aboutList({
          type: this.type,
          childrenType: 1,
        })
        .then((res) => {
          if (res.code == 200) {
            this.dataList = res.data.records;
           console.log("this.$forumApi.aboutcharacte----------", res.data);
            this.introList=res.data
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>